import MockupAdvancedForm from './MockupAdvancedForm'

export default MockupAdvancedForm
